/* Country Road Fashions — an unhurried glide for links within a page
   (Darvesh 2026-10-04: "See how" and the like jumped; make it smoother).
   Any link to #something on the same page eases there instead of cutting,
   stopping just clear of the sticky header. A wheel, touch or key press
   hands control straight back; reduced motion keeps the plain jump. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  let frame = 0;

  const headerOffset = () => {
    let h = 0;
    document.querySelectorAll('.shopify-section-group-header-group, sticky-header').forEach((el) => {
      const pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') h = Math.max(h, el.getBoundingClientRect().height);
    });
    return h;
  };

  const stop = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
  };
  ['wheel', 'touchstart', 'keydown'].forEach((type) => window.addEventListener(type, stop, { passive: true }));

  const glide = (target) => {
    stop();
    // A whole section lands flush under the header (it brings its own
    // padding); anything smaller keeps a little air above it.
    const flush = target.matches('section, .shopify-section, .shopify-section > :first-child');
    const gap = headerOffset() + (flush ? 0 : 24);
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const to = Math.min(max, Math.max(0, window.scrollY + target.getBoundingClientRect().top - gap));
    const from = window.scrollY;
    const distance = to - from;
    if (Math.abs(distance) < 2) return;
    // Longer trips take a little longer, never more than about a second and a half.
    const duration = Math.min(1500, Math.max(750, 500 + Math.abs(distance) * 0.3));
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      window.scrollTo(0, from + distance * ease(t));
      frame = t < 1 ? requestAnimationFrame(step) : 0;
    };
    frame = requestAnimationFrame(step);
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href*="#"]');
    if (!link || link.target === '_blank') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
    const id = decodeURIComponent(url.hash.slice(1));
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    if (url.hash !== location.hash) history.pushState(null, '', url.hash);
    if (reduce.matches) {
      target.scrollIntoView();
    } else {
      glide(target);
    }
    // Move keyboard focus with the eye, without a second jump.
    if (!target.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) {
      target.setAttribute('tabindex', '-1');
    }
    target.focus({ preventScroll: true });
  });
})();
